import React from 'react';
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import '../components/css components/Navbarr.css';
import logo from '../images/logo_mega.jpg';
import about from './About';

function Navbarr() {
    // function scrollToSection(sectionId) {
    //     const section = document.getElementById(about);
    //     if (section) {
    //       section.scrollIntoView({ behavior: 'smooth' });
    //     }
    //   }
    return (
        <div className="Nav nav2">
        <Navbar className='nav' fixed='top' expand="lg">
            <Container>
            <Navbar.Brand href="##home" className='mega'>
                <img src={logo} alt="logo" className="logo" />
                MEGA
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto">
                <Nav.Link className='custom' href='##home'>Home</Nav.Link>
                <Nav.Link className='custom' href='##about'>About</Nav.Link>
                <Nav.Link href="##board" className='custom'>Board</Nav.Link>
            <NavDropdown title="Circles" id="collasible-nav-dropdown">
                    <NavDropdown.Item><Link to={'/logistics'} className='drop-item'>Logistics</Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={'/media'} className='drop-item'>Media</Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={'/pr'} className='drop-item'>PR&FR</Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={'/rd'} className='drop-item'>R&D</Link></NavDropdown.Item>
                    <NavDropdown.Item><Link to={'/hr'} className='drop-item'>HR</Link></NavDropdown.Item>
                </NavDropdown>
                <Nav.Link href="##join" className='custom'>Join us</Nav.Link>
                </Nav>
            </Navbar.Collapse>
            </Container>
        </Navbar>
        </div>
    );
}

export default Navbarr;